import React, { useEffect, useState } from 'react';
import { Alert, Badge, Button, Card, Spinner, Table } from 'react-bootstrap';
import UserLayout from '../../components/user/UserLayout';
import api from '../../lib/api';
import { useToast } from '../../components/common/ToastProvider';
import { Link } from 'react-router-dom';

export default function UserNotificationsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState({ count: 0, page_size: 25 });
  const { showToast } = useToast();

  const load = async () => {
    try {
      setLoading(true);
      const { data } = await api.get('/handover/notifications/', { params: { page, page_size: 25 } });
      setItems(data?.results || []);
      setMeta({ count: data?.count || 0, page_size: data?.page_size || 25 });
    } catch (e) {
      showToast(e?.response?.data?.error || 'Failed to load notifications.', 'danger');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [page]);

  const markAll = async () => {
    try {
      await api.post('/handover/notifications/', { mark_all: true });
      showToast('Notifications marked as read.', 'success');
      load();
    } catch (e) {
      showToast(e?.response?.data?.error || 'Failed to mark notifications.', 'danger');
    }
  };
  const markOne = async (notificationId) => {
    try {
      await api.post(`/handover/notifications/${notificationId}/read/`, {});
      load();
    } catch (e) {
      showToast(e?.response?.data?.error || 'Failed to mark notification.', 'danger');
    }
  };
  const hasNext = page * meta.page_size < meta.count;

  return (
    <UserLayout title="Notifications" subtitle="Handover alerts and queue updates">
      <Card className="user-card p-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="user-section-title mb-0">Handover Notifications</div>
          <Button size="sm" onClick={markAll}>Mark all read</Button>
        </div>
        {loading ? <div className="text-center py-4"><Spinner animation="border" /></div> : (
          <div className="table-responsive">
            <Table hover className="align-middle">
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Title</th>
                  <th>Message</th>
                  <th>Handover</th>
                  <th>Created</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {items.map((n) => (
                  <tr key={n.id}>
                    <td><Badge bg={n.is_read ? 'secondary' : 'warning'}>{n.is_read ? 'Read' : 'Unread'}</Badge></td>
                    <td>{n.title}</td>
                    <td>{n.message}</td>
                    <td>{n.handover ? <Link to={`/dashboard/agent-inbox?handover_id=${n.handover}`}>Open #{n.handover}</Link> : '-'}</td>
                    <td>{n.created_at ? new Date(n.created_at).toLocaleString() : '-'}</td>
                    <td>{n.is_read ? '-' : <Button size="sm" variant="outline-secondary" onClick={() => markOne(n.id)}>Mark read</Button>}</td>
                  </tr>
                ))}
                {!items.length ? (
                  <tr><td colSpan={6}><Alert variant="light" className="mb-0">No notifications.</Alert></td></tr>
                ) : null}
              </tbody>
            </Table>
          </div>
        )}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <div className="small text-muted">Total: {meta.count}</div>
          <div className="d-flex gap-2">
            <Button size="sm" variant="outline-secondary" disabled={page <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>Previous</Button>
            <Button size="sm" variant="outline-secondary" disabled={!hasNext} onClick={() => setPage((p) => p + 1)}>Next</Button>
          </div>
        </div>
      </Card>
    </UserLayout>
  );
}
